export default __webpack_public_path__ + "static/media/background.66c50ed2.svg";